/* Dedicated overlay class — do not use global `.wrapper` (page layout uses it). */
.ej-modal-overlay,
.modal.wrapper {
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    z-index: 13000;
    isolation: isolate;
}

.ej-modal-overlay .ej-modal-dialog,
.modal.wrapper .content {
    width: 100%;
    max-width: 540px;
    border: none;
    background-color: #EAE8E8;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 32px;
    border-radius: 20px;
    box-sizing: border-box;
    flex-shrink: 0;
}

.ej-modal-dialog .buttons-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}

.ej-modal-dialog .main-text {
    margin: 0;
    font-size: 18px;
    line-height: 1.4;
    font-weight: 400;
    font-family: "Helvetica Neue", sans-serif;
    color: #032320CC;
}
